import type React from "react";
import { CheckIcon } from "~/components/icons/CheckIcon";
import { ErrorIcon } from "~/components/icons/ErrorIcon";
import { ExclamationMarkIcon } from "~/components/icons/ExclamationMarkIcon";
import type { Color } from "~/components/icons/helper";
import { InfoIcon } from "~/components/icons/InfoIcon";

// "11184809" is defined as UnknownDefaultOpenApi at Ory Kratos
// This is not expected pattern and OpenAPI generator issue so we don't handle it in triton.
export type AlertType = "info" | "error" | "warning" | "success" | "11184809";

interface Props {
	type: AlertType;
	color: Color;
}

export const InfoTypeIcon: React.FC<Props> = ({ type, color }) => {
	switch (type) {
		case "info":
			return <InfoIcon color={color} />;
		case "error":
			return <ErrorIcon color={color} />;
		case "warning":
			return <ExclamationMarkIcon color={color} />;
		case "success":
			return <CheckIcon color={color} />;
	}
};
